module.exports = __webpack_public_path__ + "img/4.abc7eaae.svg";